module.exports = __webpack_public_path__ + "img/redo.eec730b8.svg";